
import React from "react";
import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";

interface SkillsSearchProps {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
}

export const SkillsSearch = ({ searchQuery, setSearchQuery }: SkillsSearchProps) => {
  return (
    <div className="relative flex-1">
      <Search className="absolute left-2 top-2.5 h-4 w-4 text-gray-500" />
      <Input
        placeholder="Search skills..."
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        className="pl-8"
      />
    </div>
  );
};
